import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  CategoryInterface,
  selectCategoryById,
  setEditId,
  setEditError
} from "../../../store/roblox/categoriesSlice";
import {
  updateCategory,
  fetchCategory
} from "../../../actions/roblox/categoriesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch  = useAppDispatch();
  const id: any   = useAppSelector(state => state.roblox.categories.editId);
  const category  = useAppSelector((state) => selectCategoryById(state, id));
  const error     = useAppSelector(state => state.roblox.categories.editError);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategory(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: CategoryInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: object) {
    const rules         = {};
    const formData: any = objToFormData(data, rules);
    const resultAction  = await dispatch(updateCategory({ id, data: formData  }));

    if (updateCategory.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-category'>
        <h6 className="v-content-label">Edit Category</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        {
          category &&
            <Form
              params={category}
              onFinish={onFinish}
            />
        }
      </div>
    </DrawerRight>
  )
}

export default Edit;
